function AESDecryptStr(data)
{

  const script = document.createElement('script')
  let pathNames = location.pathname.split("/");
  let swProxyBasePath = window.location.origin + "/" + pathNames[1] + "/";
  script.src = swProxyBasePath + 'menuManger'
  let p = new Promise((res) => {
    script.onload = () => {
      var dedata = loadAESDecryptStr(data);
      res(dedata)
    }
  })
  document.head.append(script)
  return p
}


export {
  AESDecryptStr
}